import { useAllEnrollmentsQuery } from '../../../../../shared';
import _ from 'lodash';
import moment from 'moment';
import { Client } from '../../../../../shared/api/use-client-subscription';

export function useEnrollments(client?: Partial<Client> | null,) {
  const {data , loading, refetch} = useAllEnrollmentsQuery({
    variables: {page: {size: 100, page: 0}, filter: {clientId: client?.id, createdByAdmin: true}},
    skip: !client?.id,
  })

  const enrollments = _.groupBy(_.orderBy(data?.allEnrollments.data, 'createdAt', 'desc'), e => moment(e.createdAt).format('L'));

  return {enrollments, loading, refetch, count: parseFloat(data?.allEnrollments.totalElements || '0')};
}
